export default [
    { value: 'ContaPoupanca', text: 'Conta poupanca' },
    { value: 'ContaCorrente', text: 'Conta corrente' }
]